import '@/assets/styles/views/coach/instant-meetings.scss';
import InstantMeetingsDefaultState from '@/screens/coach/instant-meetings/states/default.tsx';
import InstantMeetingsSearchingState from '@/screens/coach/instant-meetings/states/searching.tsx';
import InstantMeetingsFoundState from '@/screens/coach/instant-meetings/states/found.tsx';
import { useMeeting } from '@/context/meeting-context';
import { CALL_SERVICE_TYPES, CALL_STATE_TYPES, MEETING_TYPE } from '@/constants/socket.ts';
import ActiveMeeting from '@/screens/coach/instant-meetings/states/active-meeting.tsx';
import { useEffect, useState } from 'react';
import { AvailableHourResponse } from '@dopingtech/live_expert_bff_api_ts';
import { useServerTimeStore } from '@/zustand/server-time/store.ts';
import { useApi } from '@/api/useApi.tsx';
import { useQueryProvider } from '@/hooks';
import { QUERY_KEYS } from '@/constants/QueryKeys.ts';
import { formatTimeHHmm, isNowInRange } from '@/utility';

const InstantCall = () => {
	const { callState, handleSearchUser, onCancelSearch, connectionApp, socketData, isSearchLoading } = useMeeting();
	const [isSearchDisabled, setIsSearchDisabled] = useState<boolean>(false);
	const [availableHours, setAvailableHours] = useState<AvailableHourResponse>({});

	const isCoachingAppointment = connectionApp === CALL_SERVICE_TYPES.COACHING && callState === CALL_STATE_TYPES.FOUND && socketData?.handleMatch?.meeting?.meetingType === MEETING_TYPE.APPOINTMENT;

	const isGotItActive = connectionApp === CALL_SERVICE_TYPES.GOT_IT && callState !== CALL_STATE_TYPES.DEFAULT;

	const { data: serverTimeData } = useServerTimeStore();
	const { AvailableHourControllerApi, PoolControllerApi } = useApi();

	const { data: availableHoursData } = useQueryProvider([QUERY_KEYS.searchAvailableHours], () => AvailableHourControllerApi.searchAvailableHours(), {
		select: ({ data }) => data.data,
		enabled: true
	});

	const { data: waitingStudent } = useQueryProvider(
		[QUERY_KEYS.getExpertCounterpartCountLookingForMatch],
		() => PoolControllerApi.getExpertCounterpartCountLookingForMatch(CALL_SERVICE_TYPES.COACHING),
		{
			select: ({ data }) => data.data,
			enabled: true
		}
	);

	useEffect(() => {
		const activeData = availableHoursData?.find(data => data?.liveServiceGroup === CALL_SERVICE_TYPES.COACHING);
		if (activeData) {
			const isActive = isNowInRange({
				nowTime: serverTimeData?.serverTime,
				startTime: activeData?.startTime,
				endTime: activeData?.endTime
			});

			setIsSearchDisabled(!isActive);
			setAvailableHours(activeData);
		}
	}, [availableHoursData]);

	if (connectionApp === CALL_SERVICE_TYPES.COACHING && callState === CALL_STATE_TYPES.CONNECT) {
		return (
			<section className={'container instant-meetings'}>
				<ActiveMeeting />
			</section>
		);
	}

	if (isCoachingAppointment || isGotItActive) {
		return (
			<section className={'container instant-meetings'}>
				<InstantMeetingsDefaultState
					isSearchDisabled={true}
					onSearchUser={() => handleSearchUser({ serviceGroup: CALL_SERVICE_TYPES.COACHING })}
					waitingStudent={waitingStudent || 0}
					isSearchLoading={false}
				/>
			</section>
		);
	}

	return (
		<section className="container instant-meetings">
			{(callState === CALL_STATE_TYPES.DEFAULT || connectionApp === CALL_SERVICE_TYPES.GOT_IT) && (
				<InstantMeetingsDefaultState
					onSearchUser={() =>
						handleSearchUser({
							serviceGroup: CALL_SERVICE_TYPES.COACHING.toString()
						})
					}
					tooltipText={`Rehberlik görüşmelerini ${formatTimeHHmm(availableHours?.startTime)} - ${formatTimeHHmm(availableHours?.endTime)} saatleri arasında yapabilirsin.`}
					isSearchDisabled={isSearchDisabled}
					isSearchLoading={isSearchLoading}
					waitingStudent={waitingStudent || 0}
				/>
			)}

			{callState === CALL_STATE_TYPES.SEARCHING && (
				<InstantMeetingsSearchingState
					onStopSearchUser={onCancelSearch}
					waitingStudent={waitingStudent || 0}
				/>
			)}

			{callState === CALL_STATE_TYPES.FOUND && <InstantMeetingsFoundState />}
		</section>
	);
};

export default InstantCall;
